import httpClient from "Api/httpClient";

const END_POINT = "/machines";

const getMachines = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getMachine = (machine_id) => {
    if (!machine_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + machine_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printMachine = (machine_id) => {
    if (!machine_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?machine_id=" + machine_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createMachines = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateMachines = (payload, machine_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + machine_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteMachines = (machine_id) => {
    const DELETE_END_POINT = END_POINT + "/" + machine_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const addMachineLogo = (payload, machine_id) => {
    let body = "";
    if (payload.body) body = payload.body;
    const ADD_LOGO_END_POINT = END_POINT + "/" + machine_id + "/photo";
    return httpClient.post(ADD_LOGO_END_POINT, body);
};

export { getMachines, getMachine, printMachine, createMachines, updateMachines, deleteMachines, addMachineLogo };
